"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiTransaction = void 0;
const errors_1 = require("../errors");
const utils_1 = require("../utils");
const MultiAction_1 = require("./MultiAction");
class MultiTransaction {
    transactions;
    constructor() {
        this.transactions = [];
    }
    get transaction() {
        if (this.transactions.length === 0) {
            throw new errors_1.MultiTransactionError('Transaction not found. Use `.batch` to add a transaction');
        }
        return this.transactions[this.transactions.length - 1];
    }
    addTransactions(transactions) {
        this.transactions.push(...transactions);
        return this;
    }
    static fromTransactions(transactions) {
        return MultiTransaction.new().addTransactions(fromTransactions(transactions));
    }
    toTransactions() {
        return toTransactions(this.transactions);
    }
    countTransactions() {
        return this.transactions.length;
    }
    countActions() {
        return this.transaction.mAction.countActions();
    }
    extend(mTransaction) {
        return this.addTransactions(mTransaction.transactions);
    }
    static new() {
        return new MultiTransaction();
    }
    /**
     * Create a transaction
     */
    static batch(receiverId, signerId) {
        return MultiTransaction.new().batch(receiverId, signerId);
    }
    /**
     * Add a transaction following previous transactions
     */
    batch(receiverId, signerId) {
        return this.addTransactions([{ signerId, receiverId, mAction: MultiAction_1.MultiAction.new() }]);
    }
    /**
     * Add actions following previous actions
     */
    addMultiAction(mAction) {
        this.transaction.mAction.extend(mAction);
        return this;
    }
    /**
     * Add a CreateAccount Action following previous actions
     */
    createAccount() {
        this.transaction.mAction.createAccount();
        return this;
    }
    /**
     * Add a DeleteAccount Action following previous actions
     */
    deleteAccount(beneficiaryId) {
        this.transaction.mAction.deleteAccount(beneficiaryId);
        return this;
    }
    /**
     * Add a AddKey Action following previous actions
     */
    addKey(publicKey, accessKey) {
        this.transaction.mAction.addKey(publicKey, accessKey);
        return this;
    }
    /**
     * Add a DeleteKey Action following previous actions
     */
    deleteKey(publicKey) {
        this.transaction.mAction.deleteKey(publicKey);
        return this;
    }
    /**
     * Add a DeployContract Action following previous actions
     */
    deployContract(code) {
        this.transaction.mAction.deployContract(code);
        return this;
    }
    /**
     * Add a Stake Action following previous actions
     */
    stake(amount, publicKey) {
        this.transaction.mAction.stake(amount, publicKey);
        return this;
    }
    /**
     * Add a FunctionCall Action following previous actions
     */
    functionCall(options) {
        this.transaction.mAction.functionCall(options);
        return this;
    }
    /**
     * Add a Transfer Action following previous actions
     */
    transfer(amount) {
        this.transaction.mAction.transfer(amount);
        return this;
    }
    get ft() {
        return (0, utils_1.fungibleTokenFunctionCall)((options) => this.functionCall(options));
    }
    get nft() {
        return (0, utils_1.nonFungibleTokenFunctionCall)((options) => this.functionCall(options));
    }
    get storage() {
        return (0, utils_1.storageManagementFunctionCall)((options) => this.functionCall(options));
    }
}
exports.MultiTransaction = MultiTransaction;
function fromTransactions(transactions) {
    return transactions.map(({ signerId, receiverId, actions }) => ({
        signerId,
        receiverId,
        mAction: MultiAction_1.MultiAction.fromActions(actions),
    }));
}
function toTransactions(transactions) {
    return transactions.map(({ signerId, receiverId, mAction }) => ({
        signerId,
        receiverId,
        actions: mAction.toActions(),
    }));
}
//# sourceMappingURL=MultiTransaction.js.map